import { render, staticRenderFns } from "./FrameModalPopup.vue?vue&type=template&id=a731d1c2&scoped=true"
import script from "./FrameModalPopup.vue?vue&type=script&lang=js"
export * from "./FrameModalPopup.vue?vue&type=script&lang=js"
import style0 from "./FrameModalPopup.vue?vue&type=style&index=0&id=a731d1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a731d1c2",
  null
  
)

export default component.exports